import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {MatTableDataSource} from '@angular/material';
import { Disciplina } from '../../../models/disciplina';
import { DisciplinaService } from '../../../services/disciplina-service';
import { Curso } from '../../../models/curso';
import { CursoService } from '../../../services/curso-service';

@Component({
  selector: 'app-lista-disciplina',
  templateUrl: './lista-disciplina.component.html',
  styleUrls: ['./lista-disciplina.component.scss']
})
export class ListaDisciplinaComponent implements OnInit {

  disciplinas: Disciplina[] = [];
  displayedColumns = ['nome', 'qtdProvas', 'curso'];
  dataSource: any;
  cursos: any = {};
  constructor(public disciplinaService: DisciplinaService, public cursoService: CursoService) {

  }

  ngOnInit() {
    this.cursoService.getSnapshot().then(res => {
      res.forEach(c => {
        this.cursos[c.key] = c.val();
      });
      this.disciplinaService.getSnapshot().then((res1) => {
        res1.forEach(r => {
          const disciplina = r.val();
          disciplina.id = r.key;

          disciplina.size = 0;
          for (const x in r.val().provas) {
            if (x) {
              disciplina.size++;
            }
          }
          disciplina.cursoName = this.getCurso(disciplina.curso);
          this.disciplinas.push(disciplina);
        });
        this.disciplinas.sort(this.compare);
        this.dataSource = new MatTableDataSource(this.disciplinas);
      });
    });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  compare(a, b) {
    if (a.name < b.name) {
      return -1;
    }
    return 1;
  }

  getCurso(x) {
    if (this.cursos[x]) {
      return this.cursos[x].name;
    }
  }

}
